import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pillows_blankets: FaireCategoryEntity = {
  token: "cat_pillows-blankets",
  type: "category",
  name: "Throw blankets",
  level: 3,
  parentToken: "cat_home-decor-pillows",
  href: "/category/home-decor/throw-pillows-blankets/throw-blankets",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
